import { LearnAudioSession } from '../audio/learn_audio_session.ts';

// What a tap the exercise keeps gives back the moment it lands (issue #3710): a haptic tick, and
// the percussive hit the pattern was played with only where it can sound with the tap.
//
// A sound played in answer to a tap leaves the speaker a device's output delay later. The iPhone
// reports about 13 ms, which the ear takes as the tap itself; the Samsungs measured for #3374
// report 240 to 265 ms, and a hit that late is an echo that throws the singer off the beat. Web
// Audio cannot shorten it: with the smallest latency hint the A16 reports less but its measured
// speaker-to-mic round trip stays 390 to 425 ms. So above tapSoundMaxDelayMs the tap is silent and
// the tick carries it. The tick goes nowhere near the audio path: navigator.vibrate is supported
// by Android Chrome and the WebView (the store app declares VIBRATE from 24.0) and absent on iOS,
// where the hit sounds instead.
export const tapSoundMaxDelayMs = 60;
export const tapVibrationMs = 40;

export function giveTapFeedback(audio: LearnAudioSession) {
  if ('vibrate' in navigator) {
    navigator.vibrate(tapVibrationMs);
  }
  const delayMs = audio.outputDelayMs();
  if (delayMs !== undefined && delayMs <= tapSoundMaxDelayMs) {
    audio.schedulePercussion(audio.nowMs());
  }
}
